export default __webpack_public_path__ + "static/media/MollierCondensing.4a11bbd2.svg";